// extracted by mini-css-extract-plugin
export var column = "column-3Z3";
export var col_width_one_fourth = "col_width_one_fourth-3-v";
export var col_width_one_third = "col_width_one_third-2Ks";
export var col_width_one_half = "col_width_one_half-2KY";
export var col_width_two_thirds = "col_width_two_thirds-1zU";
export var col_width_three_fourths = "col_width_three_fourths-UkW";